import { Button, Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle, Caption1 } from '@fluentui/react-components';
import { CellMono } from '../common';
import { formatBytes, type Release } from '../../api/releases';

export function NotesDialog({ productName, release, onClose }: { productName: string; release: Release; onClose: () => void }) {
  return (
    <Dialog open onOpenChange={(_, d) => { if (!d.open) onClose(); }}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>{productName} {release.version}</DialogTitle>
          <DialogContent>
            <p style={{ whiteSpace: 'pre-wrap', marginTop: 0 }}>{release.notes || 'No notes.'}</p>
            {release.status === 'Withdrawn' && (
              <p><b>Withdrawn:</b> {release.withdrawnReason}{release.withdrawnBy ? ` (${release.withdrawnBy})` : ''}</p>
            )}
            <Caption1 block>{release.fileName} · {formatBytes(release.sizeBytes)}</Caption1>
            <Caption1 block style={{ marginTop: 6 }}>sha256</Caption1>
            <CellMono>{release.sha256}</CellMono>
          </DialogContent>
          <DialogActions><Button appearance="primary" onClick={onClose}>Close</Button></DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}
